import React from 'react';
import ModalWrapper from '../../../ModalWrapper';
import { CommonFooter } from '../../../FormComponent';
import styles from '../../../../styles/automation/popup.module.scss';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const DEFAULT_MESSAGE =
    'Are you sure you want to save the execution record? This will overwrite the existing automation instruction.';

const INSTRUCTION_ONLY_TITLE = 'Save instructions only?';
const INSTRUCTION_ONLY_MESSAGE =
    'Saving will update the automation instructions only. The current automation plan will be removed and the test case will be marked Not Automated.';

function FailedRecordingStepsMessage({ failedSteps = [] }) {
    const count = failedSteps.length;
    const stepLabel = count === 1 ? 'step' : 'steps';
    const stepNumbersText = failedSteps.map((step) => step.stepNumber).join(', ');

    return (
        <p className={styles.message}>
            <strong>{count === 1 ? 'Step ' : 'Steps '}
            {stepNumbersText}</strong>
            {count === 1
                ? ' did not pass during recording. It will be '
                : ' did not pass during recording. They will be '}
            <strong>skipped when you replay</strong>
            {' this plan. Review and fix the affected '}
            {stepLabel}
            {' now, or '}
            <strong>save the plan</strong>
            {' and address them later.'}
        </p>
    );
}

export default function ConfirmSaveExecutionRecord({
    onClose,
    onBack,
    onSave,
    failedSteps = [],
    message = DEFAULT_MESSAGE,
    title,
    confirmLabel,
    variant = 'default',
}) {
    const isInstructionOnly = variant === 'instructionsOnly';
    const hasFailedRecordingSteps = !isInstructionOnly && failedSteps.length > 0;
    const resolvedTitle =
        title ??
        (isInstructionOnly
            ? INSTRUCTION_ONLY_TITLE
            : hasFailedRecordingSteps
              ? 'Save plan with failed steps?'
              : 'Confirm Save Execution Record');
    const resolvedMessage = isInstructionOnly ? INSTRUCTION_ONLY_MESSAGE : message;
    const resolvedConfirmLabel =
        confirmLabel ?? (isInstructionOnly ? 'Save Instructions' : hasFailedRecordingSteps ? 'Save Plan' : 'Save');

    const handleKeepEditing = onBack ?? onClose;

    const buttons = hasFailedRecordingSteps
        ? [
              {
                  label: 'Keep Editing',
                  variant: 'outline',
                  className: 'primary',
                  onClick: handleKeepEditing,
              },
              {
                  label: resolvedConfirmLabel,
                  variant: 'primary',
                  className: 'white bg-blue600',
                  onClick: onSave,
              },
          ]
        : [
              {
                  label: 'Go Back',
                  variant: 'outline',
                  className: 'primary',
                  onClick: handleKeepEditing,
                  startIcon: <ArrowLeftIcon className="icon primary" />,
              },
              {
                  label: resolvedConfirmLabel,
                  variant: 'primary',
                  className: 'white bg-blue600',
                  onClick: onSave,
              },
          ];

    return (
        <ModalWrapper
            isOpen
            onClose={handleKeepEditing}
            title={resolvedTitle}
            footer={<CommonFooter buttons={buttons} align="right" />}
        >
            {hasFailedRecordingSteps ? (
                <FailedRecordingStepsMessage failedSteps={failedSteps} />
            ) : (
                <p className={styles.message}>{resolvedMessage}</p>
            )}
        </ModalWrapper>
    );
}
